import React, { createContext, useContext, useState, useCallback } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const AppConfirmContext = createContext();

export function useAppConfirm() {
    return useContext(AppConfirmContext);
}

export function AppConfirmProvider({ children }) {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState({});
    const [resolver, setResolver] = useState(null);

    const confirm = useCallback(({
        title = 'Are you sure?',
        content = '',
        confirmText = 'Confirm',
        cancelText = 'Cancel'
    } = {}) => {
        setOptions({ title, content, confirmText, cancelText });
        setOpen(true);
        return new Promise((resolve) => {
            setResolver(() => resolve);
        });
    }, []);

    const handleClose = (result) => {
        setOpen(false);
        if (resolver) resolver(result);
    };

    return (
        <AppConfirmContext.Provider value={{ confirm }}>
            {children}
            <Dialog open={open} onClose={() => handleClose(false)}>
                <DialogTitle>{options.title}</DialogTitle>
                <DialogContent>
                    <Typography>{options.content}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose(false)}>{options.cancelText || 'Cancel'}</Button>
                    <Button onClick={() => handleClose(true)} variant="contained" color="primary">
                        {options.confirmText || 'Confirm'}
                    </Button>
                </DialogActions>
            </Dialog>
        </AppConfirmContext.Provider>
    );
}